module.exports = __webpack_public_path__ + "img/page_3.7b4b21d5.png";